import { Button, PageHeader } from '@lmc/ui-kit'
import Glyph from 'LEGACY/Glyph'
import { ProTag } from 'components/ProTag'
import { useRouter } from 'hooks/useRouter'
import { FC } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { useTranslation } from 'react-i18next'

type Props = {
  handleToggleModal: () => void
  handleView: () => void
  residentName: string | undefined
  testId?: string
}

const isDesktop = isBrowser || isTablet

export const ResidentNeedsHeaderSection: FC<Props> = ({
  handleToggleModal,
  residentName,
  testId,
}) => {
  const { t } = useTranslation()

  const router = useRouter()

  const pageHeaderTitle = residentName
    ? `${residentName}'s ${t('skillsAndNeeds.needs')}`
    : t('skillsAndNeeds.needs')

  return (
    <div
      style={styles.wrapper}
      data-testid={
        testId ? `${testId}-needs-header-section` : 'needs-header-section'
      }
    >
      <PageHeader
        sticky
        onBack={!isDesktop ? () => router.navigate(-1) : undefined}
        title={
          <div style={styles.flex}>
            {pageHeaderTitle} <ProTag />
          </div>
        }
        data-testid={
          testId ? `${testId}-needs-page-header` : 'needs-page-header'
        }
      >
        <Button
          onClick={handleToggleModal}
          icon={
            <Glyph
              name="plus"
              aphroditeStyles={undefined}
              className={undefined}
              color={undefined}
              component={undefined}
              size={undefined}
              style={undefined}
            />
          }
          variant="primary"
          data-testid={
            testId ? `${testId}-needs-add-button` : 'needs-add-button'
          }
        >
          {t(`skillsAndNeeds.assignNewNeedButton`)}
        </Button>
      </PageHeader>
    </div>
  )
}

const styles = {
  logoIcon: {
    width: 26,
    height: 26,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    marginBottom: 24,
  },
}

export default ResidentNeedsHeaderSection
